import { useEffect } from "react"

export function useIframeHandle(urlOrigin: string, postMessageCallback: { (event: MessageEvent): void }) {
    const handlePostMessage = (e: MessageEvent) => {
        // 对消息来源origin做一下过滤，避免接收到非法域名的消息导致的xss攻击 
        if(urlOrigin.includes(e.origin) && postMessageCallback) {
            // console.log(e.data) // 发送的消息
            postMessageCallback(e)
        }
    }
    window.removeEventListener('message', handlePostMessage)
    window.addEventListener('message', handlePostMessage, false)
    useEffect(() => {
        return () =>{
            window.removeEventListener('message', handlePostMessage)
        }
    })
}